import { IsNumber, isLessThanEqual100 } from '@core/services/csv/CSVCustomValidator'

import { Expose, Transform } from 'class-transformer'

import { IntermediaryCsvModel } from './IntermediaryCsvModel'

export class ServicingVestingCSVModel extends IntermediaryCsvModel {
  filename = 'IntermediaryCSVTemplate'

  static ifamList: Array<{
    oid: string;
    nric: string;
    email: string;
    name: string;
  }> = []

  static nonIfam: Array<{
    oid: string;
    nric: string;
    email: string;
    name: string;
  }> = []

  @Expose()
  @Transform(({ value }) => parseFloat(value))
  @IsNumber()
  @isLessThanEqual100()
  private 'Commission (%)' = 12.25

  get commissionPct () {
    return this['Commission (%)']
  }

  get userSystemOid () {
    const list = this.isIfamUser ? ServicingVestingCSVModel.ifamList : ServicingVestingCSVModel.nonIfam
    return list.find(e => e.nric === this.nric)?.oid
  }

  get email () {
    const list = this.isIfamUser ? ServicingVestingCSVModel.ifamList : ServicingVestingCSVModel.nonIfam
    return list.find(e => e.nric === this.nric)?.email
  }

  get name () {
    const list = this.isIfamUser ? ServicingVestingCSVModel.ifamList : ServicingVestingCSVModel.nonIfam
    return list.find(e => e.nric === this.nric)?.name
  }
}
